<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color company-modal-header">
                                <div>
                                    <span class="company-modal-kicker">Ambiente de trabalho</span>
                                    <h5 class="modal-title mb-0" id="footerCenterBtnsModalLabel">{{ t('APP.MODAL.SELECT') }}</h5>
                                </div>
                            </div>
                            <div class="modal-body modal-open modal-height-max company-modal-body">
                                <div class="row gutters">
                                    <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                        <div class="form-group mb-0">
                                            <label for="company" class="company-search-label">Buscar empresa</label>
                                            <input type="text" name="company" v-model="companyModal" id="company"
                                                   class="form-control company-search-input" @keyup="selectCompanyModal"
                                                   placeholder="Digite o nome da companhia para buscar">
                                            <div class="company-list modal-row2">
                                                <div v-for="(company, key) in allCompanies" :key="key" class="company-list-item">
                                                    <button class="btn company-option-button"
                                                            @click="companyModalSelected(company)">
                                                        <span class="company-option-avatar">{{ company.text?.charAt(0) }}</span>
                                                        <span class="company-option-name">{{ company.text }}</span>
                                                        <span class="company-option-icon icon-keyboard_arrow_right"></span>
                                                    </button>
                                                </div>
                                                <div class="company-empty-state" v-if="!allCompanies || !allCompanies.length">
                                                    Nenhuma empresa encontrada
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";

export default {
    name: "modalCompany",
    props: {
        loadPermissions: {
            type: Boolean,
            default: false
        }
    },
    emits:['alterPermissions'],
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    data() {
        return {
            companyModal: null,
            allCompanies: JSON.parse(localStorage.getItem('companies')),
            companiesBackup: JSON.parse(localStorage.getItem('companies')),
        }
    },
    methods: {
        formatSearch(str) {
            return (str || "")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toUpperCase()
                    .trim();
        },
        selectCompanyModal() {
            const textModal = this.formatSearch(this.companyModal);
            this.allCompanies = this.companiesBackup.filter(company => {
                const text = this.formatSearch(company.text);
                return text.includes(textModal);
            });
        },
        companyModalSelected(company) {
            this.companyId = company.id;
            localStorage.removeItem('companyId');
            this.companySelected = company.id;
            this.$store.commit('showModalSelectCompany', false);
            localStorage.setItem('companyId', company.id);
            if (this.loadPermissions) {
                this.$emit('alterPermissions', company)
            } else {
                this.$router.go();
            }
        },
    }
}
</script>

<style scoped>
.company-modal-header {
    align-items: flex-start;
    padding: 1.35rem 1.5rem;
}

.company-modal-kicker {
    display: block;
    margin-bottom: 0.25rem;
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.company-modal-body {
    --company-panel: #ffffff;
    --company-panel-soft: #f8fafc;
    --company-border: #e2e8f0;
    --company-text: #0f172a;
    --company-muted: #64748b;
    --company-primary: #0e5e4e;
    padding: 1.5rem;
    overflow-x: hidden;
}

.company-search-label {
    margin-bottom: 0.45rem;
    color: var(--company-muted);
    font-size: 0.78rem;
    font-weight: 800;
}

.company-search-input {
    height: 48px;
    margin-bottom: 1rem;
    border: 1px solid var(--company-border);
    background: var(--company-panel-soft);
    color: var(--company-text);
    box-shadow: none;
}

.company-search-input:focus {
    border-color: var(--company-primary);
    box-shadow: 0 0 0 0.2rem rgba(14, 94, 78, 0.12);
}

.company-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.65rem;
    max-height: 48vh;
    padding-right: 0.25rem;
    max-width: 100%;
    overflow-x: hidden;
}

.company-list-item {
    min-width: 0;
    max-width: 100%;
}

.company-option-button {
    width: 100%;
    max-width: 100%;
    min-height: 58px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.85rem;
    padding: 0.75rem 0.9rem;
    border: 1px solid var(--company-border);
    background: var(--company-panel);
    color: var(--company-text);
    text-align: left;
    font-weight: 700;
    transition: transform .16s ease, border-color .16s ease, background-color .16s ease, box-shadow .16s ease;
}

.company-option-button:hover,
.company-option-button:focus {
    transform: translateY(-1px);
    border-color: rgba(14, 94, 78, 0.35);
    background: var(--company-panel-soft);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    color: var(--company-text);
}

.company-option-avatar {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    background: rgba(14, 94, 78, 0.12);
    color: var(--company-primary);
    font-weight: 900;
    text-transform: uppercase;
}

.company-option-name {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
    white-space: normal;
    word-break: break-word;
}

.company-option-icon {
    flex: 0 0 auto;
    color: var(--company-muted);
    font-size: 1.35rem;
}

.company-empty-state {
    padding: 1.35rem;
    border: 1px dashed var(--company-border);
    color: var(--company-muted);
    text-align: center;
    font-weight: 700;
}

@media (max-width: 575.98px) {
    .company-modal-body {
        padding: 1rem;
    }

    .company-option-button {
        align-items: flex-start;
        gap: 0.65rem;
        padding: 0.75rem;
    }

    .company-option-name {
        flex-basis: calc(100% - 48px);
    }

    .company-option-icon {
        margin-left: auto;
    }
}

</style>
